import { render, staticRenderFns } from "./ThankyouPayment.vue?vue&type=template&id=30396a06"
import script from "./ThankyouPayment.vue?vue&type=script&lang=js"
export * from "./ThankyouPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports